// extracted by mini-css-extract-plugin
module.exports = {"body":"styles_body__1pZzC","input":"styles_input__1Puc8","icon":"styles_icon__2mM-x"};